import React from "react";
import { HashRouter } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { createBrowserHistory } from "history";

import { Provider as StoreProvider } from "react-redux";
import { configureStore } from "./store";
import routes from "./routes";

import ReactGA from 'react-ga';

const history = createBrowserHistory();
const store = configureStore();

function initializeAnalytics(){
  ReactGA.initialize('G-DM9GLDE0CJ');
  ReactGA.pageview(window.location.pathname + window.location.search);
}

const App = () => {
  initializeAnalytics()
  return (
    <StoreProvider store={store}>
      <HashRouter history={history}>{renderRoutes(routes)}</HashRouter>
    </StoreProvider>
  );
};

export default App;
